import { gql } from "@apollo/client";

export default gql`
  mutation deleteOrgWideCompetency($competencyId: Int!) {
    deleteCompetency(competencyId: $competencyId) {
      ok
    }
  }
`;
